import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

const COLORS = {
  academic: "#500000", library: "#1d4ed8", student_center: "#7c3aed",
  dining: "#F59E0B", rec: "#16a34a", stop: "#0a0a0a",
  athletics: "#7c3aed", health: "#0891b2", services: "#ea580c",
};

const dot = (color) =>
  L.divIcon({
    className: "",
    html: `<div style="width:16px;height:16px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.45);cursor:grab"></div>`,
    iconSize: [16, 16],
    iconAnchor: [8, 8],
  });

export default function OnboardPreviewMap({ draft, onMove }) {
  const center = Array.isArray(draft.center) && draft.center.length === 2 ? draft.center : [30, -97];
  const rows = [];
  (draft.buildings || []).forEach((b, i) => rows.push({ kind: "buildings", i, lat: b.lat, lng: b.lng, color: COLORS[b.type] || COLORS.academic, name: b.name }));
  (draft.amenities || []).forEach((a, i) => rows.push({ kind: "amenities", i, lat: a.lat, lng: a.lng, color: COLORS[a.type] || "#64748b", name: a.name }));
  (draft.bus_stops || []).forEach((s, i) => rows.push({ kind: "bus_stops", i, lat: s.lat, lng: s.lng, color: COLORS.stop, name: s.name }));
  (draft.athletics || []).forEach((a, i) => rows.push({ kind: "athletics", i, lat: a.lat, lng: a.lng, color: COLORS.athletics, name: a.name }));
  (draft.health || []).forEach((h, i) => rows.push({ kind: "health", i, lat: h.lat, lng: h.lng, color: COLORS.health, name: h.name }));
  (draft.services || []).forEach((s, i) => rows.push({ kind: "services", i, lat: s.lat, lng: s.lng, color: COLORS.services, name: s.name }));

  return (
    <div className="w-full h-[380px]" data-testid="onboard-preview-map">
    <MapContainer center={center} zoom={15} className="w-full h-full rounded-lg" zoomControl={false}>
      <TileLayer url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" />
      {rows.map((m) =>
        m.lat != null && m.lng != null ? (
          <Marker
            key={`${m.kind}-${m.i}`}
            position={[m.lat, m.lng]}
            icon={dot(m.color)}
            draggable
            eventHandlers={{
              dragend: (e) => {
                const p = e.target.getLatLng();
                onMove(m.kind, m.i, p.lat, p.lng);
              },
            }}
          >
            <Popup>{m.name}</Popup>
          </Marker>
        ) : null
      )}
    </MapContainer>
    </div>
  );
}
